module.exports = __webpack_public_path__ + "img/bwb1.svg";